import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Constants } from '../../shared/common/helper/constants';
import { HttpService } from '../../shared/common/helper/httpService';
import { PcnModel } from '../../shared/common/viewmodels/pcn.model';
import { SafePipe } from '../../shared/common/pipes/safe.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { InterfaceDocument } from '../viewmodels/interface-document';

@Injectable()
export class InterfaceService {
  private interfaceUrl = Constants.serverUrl + 'api/interface/';

  constructor(public http: HttpService,
    private sanitizer: DomSanitizer) {
  }

  /** validateToken */
  // validateToken(token: string): Observable<any> {
  //  return this.http.get(this.interfaceUrl +
  //    'validateToken' +
  //    '/' +
  //    token
  //  ).map((res: Response) => res.json());
  // }

  /** validatePcnDetails */
  validateEncryptedData(tokenData: string): Observable<any> {
    const json = {
      token: encodeURIComponent(tokenData)
    };
    return this.http.Post(this.interfaceUrl +
      'validateEncryptedData', json);
  }
  validateSiDemData(id: string, tokenData: string): Observable<any> {
    return this.http.Post(this.interfaceUrl +
      'validateSiDemData', {id, tokenData});
  }

  /** saveClientInterfaceDocument */
  saveClientInterfaceDocument(interfaceDocument: InterfaceDocument): Observable<any> {
    const data = JSON.stringify(interfaceDocument);
    return this.http.Post(this.interfaceUrl +
      'saveClientInterfaceDocument', data);
  }

}
